import { render, staticRenderFns } from "./AccountDropdown.vue?vue&type=template&id=0946be7c&scoped=true&"
import script from "./AccountDropdown.vue?vue&type=script&lang=js&"
export * from "./AccountDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AccountDropdown.vue?vue&type=style&index=0&id=0946be7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946be7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VTooltip})
